import { AbstractControl, ValidationErrors } from '@angular/forms';
import { DateUtils } from '../utils/date-utils';

export function endDateRequiredWhenBackdatedValidator(startDateControlName: string, endDateControlName: string) {
  return function (formGroup: AbstractControl): ValidationErrors | null {
    const startDateControl = formGroup.get(startDateControlName);
    const endDateControl = formGroup.get(endDateControlName);

    if (!startDateControl || !endDateControl) {
      return null;
    }

    const startDateValue = startDateControl.value;
    const endDateValue = endDateControl.value;

    if (!startDateValue) {
      if (endDateControl.hasError('endDateRequiredWhenBackdated')) {
        const errors = { ...endDateControl.errors };
        delete errors.endDateRequiredWhenBackdated;
        endDateControl.setErrors(Object.keys(errors).length > 0 ? errors : null);
      }
      return null;
    }

    const isBackdated = startDateValue < DateUtils.todayInCST();

    if (isBackdated && !endDateValue) {
      const endDateErrors = { ...endDateControl.errors };
      endDateErrors.endDateRequiredWhenBackdated = true;
      endDateControl.setErrors(endDateErrors);
    } else {
      if (endDateControl.hasError('endDateRequiredWhenBackdated')) {
        const errors = { ...endDateControl.errors };
        delete errors.endDateRequiredWhenBackdated;
        endDateControl.setErrors(Object.keys(errors).length > 0 ? errors : null);
      }
    }

    return null;
  };
}
